import { Component, ViewEncapsulation, Output, EventEmitter, ChangeDetectorRef, ViewContainerRef, ComponentFactoryResolver } from "@angular/core";
declare var jsPanel: any;
import { SharedService } from '../../shared'
import { SaveJsonPopupComponent } from '../save-json-popup';
import { LoadJsonPopupComponent } from '../load-json-popup';

@Component({
    selector: 'app-shared-component',
    template: '',
    encapsulation: ViewEncapsulation.None
})
export class SharedComponent {
    jsPanelElm: any;

    @Output() onSaveClick: any = new EventEmitter();

    constructor(private cd: ChangeDetectorRef,
        private vcr: ViewContainerRef,
        private resolver: ComponentFactoryResolver,
        private sharedService: SharedService    ) {
    }

    showSaveJSONPopup(partnerName) {
        let panels = jsPanel.getPanels();
        panels.forEach(panel => {
            panel.close();
        })

        let component = this;

        // Code for get html element from component
        const factory = this.resolver.resolveComponentFactory(SaveJsonPopupComponent);
        const componentRef = this.vcr.createComponent(factory);
        const element = componentRef.location.nativeElement;

        this.jsPanelElm = jsPanel.create({
            theme: 'dark',
            footerToolbar: [
                '<button type="button" class="btn btn-sm btn-danger mr-2" data-type="close">Stornieren</button>',
                '<button type="button" class="btn btn-sm btn-success" data-type="ok">Ok</button>'
            ],
            panelSize: {
                width: "460px",
                height: "420px"
            },
            animateIn: 'jsPanelFadeIn',
            headerTitle: 'Antrag speichern',
            onwindowresize: true,
            content: element,
            callback: function (panel) {

                // Footer button Functionality
                for (const btn of panel.footer.querySelectorAll('button')) {
                    btn.addEventListener('click', (e) => {
                        var dataType = e.target.getAttribute("data-type");
                        switch (dataType) {
                            case "ok":
                                var fileName = componentRef.instance.fileName;
                                var secretType = componentRef.instance.secretType;
                                var secretKey = componentRef.instance.secretKey;
                                component.onSaveClick({ fileName, secretType, secretKey });
                                panel.close();
                                break;
                            default:
                                panel.close();
                                break;
                        }
                    });
                }
            }
        });

        this.jsPanelElm = this.sharedService.setJsPanelProperty(this.jsPanelElm, partnerName);
    }

    showLoadJSONPopup(partnerName) {
        let panels = jsPanel.getPanels();
        panels.forEach(panel => {
            panel.close();
        })

        let component = this;

        // Code for get html element from component
        const factory = this.resolver.resolveComponentFactory(LoadJsonPopupComponent);
        const componentRef = this.vcr.createComponent(factory);
        const element = componentRef.location.nativeElement;

        this.jsPanelElm = jsPanel.create({
            theme: 'dark',
            footerToolbar: [
                '<button type="button" class="btn btn-sm btn-danger mr-2" data-type="close">Stornieren</button>',
                '<button type="button" class="btn btn-sm btn-success" data-type="ok">Ok</button>'
            ],
            panelSize: {
                width: "360px",
                height: "220px"
            },
            animateIn: 'jsPanelFadeIn',
            headerTitle: 'Secret Key',
            onwindowresize: true,
            content: element,
            callback: function (panel) {
                // Footer button Functionality
                for (const btn of panel.footer.querySelectorAll('button')) {
                    btn.addEventListener('click', (e) => {
                        var dataType = e.target.getAttribute("data-type");
                        switch (dataType) {
                            case "ok":
                                var secretKey = componentRef.instance.secretKey;
                                if (secretKey) {
                                    component.onSaveClick({ secretKey });
                                    panel.close();
                                } else {
                                    alert("Please enter secret key");
                                }
                                break;
                            default:
                                panel.close();
                                break;
                        }
                    });
                }
            }
        });

        this.jsPanelElm = this.sharedService.setJsPanelProperty(this.jsPanelElm, partnerName);
    }

    showPopupForLogin(partnerName) {
        let panels = jsPanel.getPanels();
        panels.forEach(panel => {
            panel.close();
        })

        var origin = window.location.origin;
        var path = `${origin}/cannabisantrag/doc`;
        var html = `“Login mit DocCheck: <a href="${path}" target="_blank">${path}</a>`;

        this.jsPanelElm = jsPanel.create({
            theme: 'dark',
            id: "jsPanelFixed",
            headerControls: 'closeonly',
            panelSize: {
                width: () => { return window.innerWidth < 500 ? (window.innerWidth * 0.8) : 500; },
                height: 160
            },
            animateIn: 'jsPanelFadeIn',
            headerTitle: 'Nur für medizinisches Fachpersonal',
            dragit: {
                disable: true
            },
            resizeit: {
                disable: true
            },
            content: `<div class="reload-confirm-text">${html}</div>
                `,
            callback: function (panel) {

                // Footer button Functionality
                for (const btn of panel.footer.querySelectorAll('button')) {
                    btn.addEventListener('click', (e) => {
                        var dataType = e.target.getAttribute("data-type");
                        switch (dataType) {
                            case "ok":
                                panel.close();
                                break;
                            default:
                                panel.close();
                                break;
                        }
                    });
                }
            }
        });

        this.jsPanelElm = this.sharedService.setJsPanelProperty(this.jsPanelElm, partnerName);
    }

}
